import { cn } from '@/lib/cn';

export default function PageHeader({
  children,
  className,
}: {
  children: React.ReactNode | React.ReactNode[];
  className?: string;
}) {
  return (
    <div
      className={cn(
        'mb-4 flex w-full items-center justify-between bg-inherit',
        className
      )}
    >
      {children}
    </div>
  );
}
